import { useAuthStore } from "../store/auth.store";
import { useEffect, useState } from "react";
import { useVendorsStore } from "../store/vendors.store";
import { PartnerApi } from "../api/partner.api";
import { NavLink, useParams } from "react-router";
import { useVendor } from "../hook/partner/vendor.partner.hook";
import VendorDetailHome from "./Vendors/Detail/VendorDetailHome";
import VendorDetailProducts from "./Vendors/Detail/VendorDetailProducts";
import VendorDetailProductSets from "./Vendors/Detail/VendorDetailProductSets";
import PersonDetail from "../components/Person/PersonDetail";
import VendorDetailDocuments from "./Vendors/Detail/VendorDetailDocuments";
import VendorDetailWarehouseSales from "./Vendors/Detail/VendorDetailWarehouseSales";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";

function Vendor() {
  const { vendorId } = useParams();

  const vendorMutation = useVendor();

  const token = useAuthStore((state) => state.token);
  const vendor = useVendorsStore((state) => state.vendor);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);

  const [page, setPage] = useState();

  useEffect(() => {
    setPagename(vendor ? vendor.name : "");
    setBreadcrumbs([
      {
        name: "Produkty",
        link: "/produkty",
      },
    ]);
    if (vendor?.tabs?.length > 0) {
      setPage(vendor.tabs[0]);
    }
  }, [vendor]);

  useEffect(() => {
    if (token && vendorId) {
      vendorMutation.mutate({ token, vendorId });
    }
  }, [token, vendorId]);

  if (vendorMutation.isLoading) {
    return <p>Načítání</p>;
  }

  if (!vendor) {
    return <></>;
  }

  if (vendor.vendor_id != vendorId) {
    return <></>;
  }

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-4">
          <div className={"card p-5 mb-5"}>
            <img
              className="mw-100 mb-6"
              src={PartnerApi.url + "/vendor/" + vendor.vendor_id + "/logo.jpg"}
              alt={vendor.name}
            />
            {vendor.manager && (
              <>
                <h1 className="mb-4">Zodpovědná osoba:</h1>
                <PersonDetail person={vendor.manager} />
              </>
            )}

            {vendor.guarantor?.length > 0 && (
              <>
                <h1 className={"mt-6 mb-4"}>
                  Obchodní kontakt (poptávky, objednávky):
                </h1>
                <div className="row">
                  {vendor.guarantor.map((guarantor, guarantor_key) => (
                    <div
                      key={guarantor_key}
                      className={
                        vendor.guarantor.length > 1
                          ? "col-6 mb-4"
                          : "col-12 mb-4"
                      }
                    >
                      <PersonDetail person={guarantor} />
                    </div>
                  ))}
                </div>
              </>
            )}

            {vendor.presales?.length > 0 && (
              <>
                <h1 className={"mt-6 mb-4"}>
                  Presales podpora (zápůjčky zařízení, technická podpora):
                </h1>
                <div className="row">
                  {vendor.presales.map((presales, presales_key) => (
                    <div key={presales_key} className={"col-6 mb-4"}>
                      <PersonDetail person={presales} />
                    </div>
                  ))}
                </div>
              </>
            )}
            {vendor.sales_support?.length > 0 && (
              <>
                <h1 className={"mt-6 mb-4"}>
                  Obchodní podpora (objednávky, logistika):
                </h1>
                <div className="row">
                  {vendor.sales_support.map((presales, presales_key) => (
                    <div key={presales_key} className={"col-6 mb-4"}>
                      <PersonDetail person={presales} />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        {vendor && (
          <div className="col-12 col-md-8">
            <div className="card">
              <div className="card-body">
                <VendorDetailHome vendor={vendor} />

                {vendor.tabs?.length > 0 && (
                    <>
                      <ul className="mt-10 mb-5 nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                        {vendor.tabs.includes("produkty") && (
                            <li className="nav-item">
                              <span
                                  onClick={() => setPage("produkty")}
                                  className={
                                      "cursor-pointer nav-link" +
                                      (page == "produkty" ? " active" : "")
                                  }
                                  aria-current="page"
                              >
                                Produkty
                              </span>
                            </li>
                        )}
                        {vendor.tabs.includes("dokumenty") && (
                            <li className="nav-item">
                              <span
                                  onClick={() => setPage("dokumenty")}
                                  className={
                                      "cursor-pointer nav-link" +
                                      (page == "dokumenty" ? " active" : "")
                                  }
                                  aria-current="page"
                              >
                                Dokumenty
                              </span>
                            </li>
                        )}
                        {vendor.tabs.includes("samoobsluha") && (
                            <li className="nav-item">
                              <span
                                  onClick={() => setPage("samoobsluha")}
                                  className={
                                      "cursor-pointer nav-link" +
                                      (page == "samoobsluha" ? " active" : "")
                                  }
                                  aria-current="page"
                              >
                                Samoobsluha
                              </span>
                            </li>
                        )}
                        {vendor.tabs.includes("vyprodej") && (
                            <li className="nav-item">
                              <span
                                  onClick={() => setPage("vyprodej")}
                                  className={
                                      "cursor-pointer nav-link" +
                                      (page == "vyprodej" ? " active" : "")
                                  }
                                  aria-current="page"
                              >
                                Výprodej
                              </span>
                            </li>
                        )}
                      </ul>

                      {page == "produkty" && <VendorDetailProducts vendor={vendor} />}
                      {page == "dokumenty" && (
                          <VendorDetailDocuments vendor={vendor} />
                      )}
                      {page == "samoobsluha" && (
                          <VendorDetailProductSets vendor={vendor} />
                      )}
                      {page == "vyprodej" && (
                          <VendorDetailWarehouseSales vendor={vendor} />
                      )}
                    </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Vendor;
